import React, { FC } from 'react';
import { Container, makeStyles, Theme, Typography } from '@material-ui/core';
const useStyles = makeStyles((theme: Theme) => {
  return {
    h1: {
      margin: theme.spacing(9, 0, 8),
    },
    h2: {
      margin: theme.spacing(5, 0),
    },
    p: {
      marginBottom: theme.spacing(5),
      textAlign: 'left',
      [theme.breakpoints.up('md')]: {
        textAlign: 'justify',
      },
    },
    a: {
      color: theme.palette.primary.main,
      margin: theme.spacing(0, 1),
      fontStyle: 'italic',
    },
    ul: {
      margin: theme.spacing(7, 0),
      paddingLeft: 20,
      listStyle: 'circle',
      [theme.breakpoints.up('md')]: {
        textAlign: 'justify',
        paddingLeft: 40,
      },
    },
    li: {
      margin: theme.spacing(1, 0),
    },
  };
});
const PrivacyPolicy: FC = () => {
  const classes = useStyles();
  return (
    <Container maxWidth={false} fixed>
      <Typography className={classes.h1} variant="h1">
        <span>Privacy Policy for Patron Trucking</span>
      </Typography>

      <Typography className={classes.p}>
        At silverlogistics.net, accessible from https://silverlogistics.net, one of our main priorities is the privacy of our
        visitors. This Privacy Policy document contains types of information that is collected and recorded by silverlogistics.net
        and how we use it.
      </Typography>

      <Typography className={classes.p}>
        If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.
      </Typography>

      <Typography className={classes.p}>
        This Privacy Policy applies only to our online activities and is valid for visitors to our website with regards to the
        information that they shared and/or collect in silverlogistics.net. This policy is not applicable to any information
        collected offline or via channels other than this website. Our Privacy Policy was created with the help of the
        <Typography
          component={'a'}
          href="https://www.cookiepolicygenerator.com/privacy-policy-generator/"
          target={'_blank'}
          rel="noopener noreferrer"
          className={classes.a}
        >
          Privacy Policy Generator from CookiePolicyGenerator.com
        </Typography>
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>Consent</span>
      </Typography>

      <Typography className={classes.p}>
        By using our website, you hereby consent to our Privacy Policy and agree to its terms.
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>Information we collect</span>
      </Typography>

      <Typography className={classes.p}>
        The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made
        clear to you at the point we ask you to provide your personal information.
      </Typography>
      <Typography className={classes.p}>
        If you contact us directly, we may receive additional information about you such as your name, email address, phone
        number, the contents of the message and/or attachments you may send us, and any other information you may choose to
        provide.
      </Typography>
      <Typography className={classes.p}>
        When you register for an Account, we may ask for your contact information, including items such as name, company name,
        address, email address, and telephone number.
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>How we use your information</span>
      </Typography>

      <Typography className={classes.p}>We use the information we collect in various ways, including to:</Typography>

      <Typography component="ul" className={classes.ul}>
        <Typography component="li" className={classes.li}>
          Provide, operate, and maintain our website
        </Typography>
        <Typography component="li" className={classes.li}>
          Improve, personalize, and expand our website
        </Typography>
        <Typography component="li" className={classes.li}>
          Understand and analyze how you use our website
        </Typography>
        <Typography component="li" className={classes.li}>
          Develop new products, services, features, and functionality
        </Typography>
        <Typography component="li" className={classes.li}>
          Communicate with you, either directly or through one of our partners, including for customer service, to provide you
          with updates and other information relating to the website, and for marketing and promotional purposes
        </Typography>
        <Typography component="li" className={classes.li}>
          Send you emails
        </Typography>
        <Typography component="li" className={classes.li}>
          Find and prevent fraud
        </Typography>
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>Log Files</span>
      </Typography>

      <Typography className={classes.p}>
        silverlogistics.net follows a standard procedure of using log files. These files log visitors when they visit websites.
        All hosting companies do this and a part of hosting services' analytics. The information collected by log files include
        internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit
        pages, and possibly the number of clicks. These are not linked to any information that is personally identifiable. The
        purpose of the information is for analyzing trends, administering the site, tracking users' movement on the website, and
        gathering demographic information.
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>Cookies and Web Beacons</span>
      </Typography>

      <Typography className={classes.p}>
        Like any other website, silverlogistics.net uses 'cookies'. These cookies are used to store information including
        visitors' preferences, and the pages on the website that the visitor accessed or visited. The information is used to
        optimize the users' experience by customizing our web page content based on visitors' browser type and/or other
        information.
      </Typography>

      <Typography className={classes.p}>
        For more general information on cookies, please read{' '}
        <Typography
          component={'a'}
          href="https://www.privacypolicyonline.com/what-are-cookies/"
          target={'_blank'}
          rel="noopener noreferrer"
          className={classes.a}
        >
          "What Are Cookies"
        </Typography>
        Information regarding cookies from this Cookies Policy are from{' '}
        <Typography
          component={'a'}
          href="https://www.generateprivacypolicy.com/"
          target={'_blank'}
          rel="noopener noreferrer"
          className={classes.a}
        >
          the Privacy Policy Generator.
        </Typography>
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>Advertising Partners Privacy Policies</span>
      </Typography>

      <Typography className={classes.p}>
        You may consult this list to find the Privacy Policy for each of the advertising partners of silverlogistics.net.
      </Typography>

      <Typography className={classes.p}>
        Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their
        respective advertisements and links that appear on silverlogistics.net, which are sent directly to users' browser. They
        automatically receive your IP address when this occurs. These technologies are used to measure the effectiveness of their
        advertising campaigns and/or to personalize the advertising content that you see on websites that you visit.
      </Typography>

      <Typography className={classes.p}>
        Note that silverlogistics.net has no access to or control over these cookies that are used by third-party advertisers.
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>Third Party Privacy Policies</span>
      </Typography>

      <Typography className={classes.p}>
        silverlogistics.net's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult
        the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their
        practices and instructions about how to opt-out of certain options.{' '}
      </Typography>

      <Typography className={classes.p}>
        You can choose to disable cookies through your individual browser options. To know more detailed information about cookie
        management with specific web browsers, it can be found at the browsers' respective websites.
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>CCPA Privacy Rights (Do Not Sell My Personal Information)</span>
      </Typography>

      <Typography className={classes.p}>Under the CCPA, among other rights, California consumers have the right to:</Typography>
      <Typography className={classes.p}>
        Request that a business that collects a consumer's personal data disclose the categories and specific pieces of personal
        data that a business has collected about consumers.
      </Typography>
      <Typography className={classes.p}>
        Request that a business delete any personal data about the consumer that a business has collected.
      </Typography>
      <Typography className={classes.p}>
        Request that a business that sells a consumer's personal data, not sell the consumer's personal data.
      </Typography>
      <Typography className={classes.p}>
        If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please
        contact us.
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>GDPR Data Protection Rights</span>
      </Typography>

      <Typography className={classes.p}>
        We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the
        following:
      </Typography>
      <Typography className={classes.p}>
        The right to access – You have the right to request copies of your personal data. We may charge you a small fee for this
        service.
      </Typography>
      <Typography className={classes.p}>
        The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You
        also have the right to request that we complete the information you believe is incomplete.
      </Typography>
      <Typography className={classes.p}>
        The right to erasure – You have the right to request that we erase your personal data, under certain conditions.
      </Typography>
      <Typography className={classes.p}>
        The right to restrict processing – You have the right to request that we restrict the processing of your personal data,
        under certain conditions.
      </Typography>
      <Typography className={classes.p}>
        The right to object to processing – You have the right to object to our processing of your personal data, under certain
        conditions.
      </Typography>
      <Typography className={classes.p}>
        The right to data portability – You have the right to request that we transfer the data that we have collected to another
        organization, or directly to you, under certain conditions.
      </Typography>
      <Typography className={classes.p}>
        If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please
        contact us.
      </Typography>

      <Typography className={classes.h2} variant="h2">
        <span>Children's Information</span>
      </Typography>

      <Typography className={classes.p}>
        Another part of our priority is adding protection for children while using the internet. We encourage parents and
        guardians to observe, participate in, and/or monitor and guide their online activity.
      </Typography>

      <Typography className={classes.p}>
        silverlogistics.net does not knowingly collect any Personal Identifiable Information from children under the age of 13. If
        you think that your child provided this kind of information on our website, we strongly encourage you to contact us
        immediately and we will do our best efforts to promptly remove such information from our records.
      </Typography>
    </Container>
  );
};

export default PrivacyPolicy;
